import React from 'react';

const FormSidebar: React.FC = () => {
  return (
    <div className="formulario-info">
      <div className="uk-card uk-card-default uk-card-body uk-border-rounded">
        <h4 className="uk-card-title">Información Importante</h4>
        <ul className="uk-list uk-list-bullet">
          <li>Registro completamente gratuito</li>
          <li>Verificación de datos en 24-48hs</li>
          <li>Acceso inmediato a la plataforma</li>
          <li>Soporte técnico especializado</li>
          <li>Herramientas de gestión incluidas</li>
          <li>Sin comisiones ocultas</li>
        </ul>
      </div>
      
      <div className="uk-card uk-card-primary uk-card-body uk-border-rounded uk-margin-top">
        <h4 className="uk-card-title">Campos Obligatorios</h4>
        <p className="uk-text-small">
          Los campos marcados con * son obligatorios para completar el registro de tu empresa.
        </p>
      </div>
      
      <div className="uk-card uk-card-secondary uk-card-body uk-border-rounded uk-margin-top">
        <h4 className="uk-card-title">Datos de Acceso</h4>
        <p className="uk-text-small">
          Guarda tu nombre de usuario y contraseña. Te permitirán modificar la información de tu empresa en futuras ocasiones.
        </p>
      </div>
    </div>
  );
};

export default FormSidebar;
